export const de = {
    'section.digital_products': 'Digitale Lernprodukte',
    'section.episodes': 'Podcast-Folgen',
    'section.events': 'Veranstaltungen',
    'section.pages': 'Seiten',
    'section.products': 'Produkte',
    'section.projects': 'Projekte',
    'section.publications': 'Publikationen',
    'type.page': 'Seite',
    'type.episode': 'Podcast',
    'type.product': 'Produkt',
    'type.digital_product': 'Digitales Lernprodukt',
    'type.publication': 'Publikation',
    'type.event': 'Veranstaltung',
    'type.project': 'Projekt',
    'topics.title': 'Themenwelt',
    product_type: 'Produktart',
    'event_format.label': 'Veranstaltungsformat',
    target_groups: 'Zielgruppe',
    inhouse_available: 'Inhouse-Veranstaltungen',
    'inhouse_available.label': 'Als Inhouse-Veranstaltung verfügbar',
    'inhouse_available.1': 'Inhouse',
    podcast: 'Podcast',
    episode_category: 'Kategorie',
    publications_category: 'Kategorie',
    digital_format: 'Format',
    trade_sectors: 'Branchenbereich',
};
